<script lang="ts">

    export let props: string = "";

</script>
    
<style lang="scss">

    .pageheader {
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        align-items: center;
        width: 100%;
        height: 200px;
        background-image: url("../assets/images/Collectif-1920-1080-px-3.png");
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        background-attachment: scroll;
        color: $color_white;
        &__bloc {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            margin: 0 0 32px 0;
        }
        &__line {
            height: 4px;
            width: 100px;
            background-color: $color_orange;
            border-radius: 2px;
        }
        &__title {
            text-transform: uppercase;
            text-shadow: 1px 1px 2px rgb(0 0 0 / 30%);
        }
    }

    @include large {
        .pageheader {
            height: 350px;
        }
    }

</style>

<div class="pageheader">
    <div class="bloc pageheader__bloc">
        <div class="pageheader__line"></div>
        <div class="pageheader__title font__h1">{props}</div>    
    </div>
</div>